import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { flowRight, get } from 'lodash';

import { getPageloadTraceId } from '../../config/pageload/selector';
import HomePage from './HomePage';

const mapStateToProps = state => ({
    pageId: get(getPageloadTraceId(state), 'pageTraceId'),
});

export default flowRight(
    hot(module),
    connect(mapStateToProps),
)(HomePage);
